import type { CorePageStoryblok } from '~/types/storyblok-generated';

export type ModuleAppearance = 'slide' | 'slide-desktop' | 'sticky' | 'normal';

export type ModuleTheme = 'white' | 'brown-light' | 'schaerer-red' | 'media';

export interface ModuleSettings {
  appearance?: ModuleAppearance;
  buffer?: boolean;
  scrollMultiplier?: number;
  removePadding?: boolean;
  hasFullHeightOnDesktop?: boolean; // Required for horizontal scrolling module
}

type ModuleComponentName = NonNullable<CorePageStoryblok['body']>[number]['component'];
export const moduleSettingsMap: Partial<Record<ModuleComponentName, ModuleSettings>> = {
  cm_highlights: {
    appearance: 'slide',
    buffer: true,
    scrollMultiplier: 2,
    removePadding: true,
  },
  ['cm_text-highlight']: {
    appearance: 'slide',
    buffer: true,
    scrollMultiplier: 0.3,
    removePadding: true,
  },
  ['cm_stage-product-rich']: {
    appearance: 'sticky',
    scrollMultiplier: 2,
    removePadding: true,
  },
  ['cm_horizontal-scrolling']: {
    appearance: 'slide-desktop',
    buffer: false,
    scrollMultiplier: 1.5,
    removePadding: true,
    hasFullHeightOnDesktop: true,
  },
};
